/*首页功能相关路由*/
const nqjcyzt_cockpit = () =>  import("../../../studio/new_cockpit_box/cockpit_children/nqzcyzt_cockpit/nqzcyztCockpitBoxMain");
const nzxsyzt_cockpit = () =>  import("../../../studio/new_cockpit_box/cockpit_children/nzxsyzt_cockpit/nzxsyztCockpitBoxMain");
const jrznyzt_cockpit = () =>  import("../../../studio/new_cockpit_box/cockpit_children/jrznyzt_cockpit/jrznyztCockpitBoxMain");


export default [
  {
    path: '/nqjcyzt_cockpit',
    name: '农情监测一张图',
    component: nqjcyzt_cockpit
  },
  {
    path: '/nzxsyzt_cockpit',
    name: '农资销售一张图',
    component: nzxsyzt_cockpit
  },
  {
    path: '/jrznyzt_cockpit',
    name: '金融助农一张图',
    component: jrznyzt_cockpit
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/nqjcyzt/nqjcyzt_cockpit_page.js